import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _VaNavbar } from "./VaNavbar-3d7d5fa6.mjs";
import { _ as _VaNavbarItem } from "./VaNavbarItem/VaNavbarItem-af4ae844.mjs";
const VaNavbar = withConfigTransport(_VaNavbar);
const VaNavbarItem = withConfigTransport(_VaNavbarItem);
export {
  VaNavbar as V,
  VaNavbarItem as a
};
//# sourceMappingURL=index-15641e4a.mjs.map
